import React, {Fragment, useEffect, useState} from "react";
import HTTPClient from "../../HTTPClient";
import Loading from "../Loading";
import Typography from "@material-ui/core/Typography";
import Header from "../Header";
import SearchAnwers from "./SearchAnswers";
import Container from "@material-ui/core/Container";
import MeetingTitle from "../meeting/MeetingTitle";
import Box from "@material-ui/core/Box";
import BackButton from "../BackButton";
import {getMessage, loadMessages} from "../../util";



const QuestionAnswers = (props) => {

    const [loading, setLoading] = useState(true);
    const [question, setQuestion] = useState(null);
    const [meeting, setMeeting] = useState(null);
    const [meeting_id] = useState('bml90MyO');
    const [question_id] = useState(props.match.params.question_id);
    const [representative, setRepresentative] = useState(null);
    const [messages, setMessages] = useState(null);

    HTTPClient.interceptors.response.use(function (response) {

        return response;
    }, function (error) {
        switch (error.response.status) {
            case 401:
                window.location = '/login';

                break;
            default:
                return Promise.reject(error);

        }

    });


    useEffect(() => {

        const loadData = () => {

            HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id
            })
                .then(response => {
                    setLoading(false);
                    const data = response.data;

                    const open_questions = data.questions.filter(q => {
                        return (q.slug !== question_id && q.state === 'open')
                    });
                    if (open_questions.length > 0) {
                        window.location = '/meeting/question/' + open_questions[0].slug;
                        return;
                    }

                    //if (JSON.stringify(data) !== JSON.stringify(meeting)) {
                    // really lazy way to compare meetings
                    setMeeting(data);
                    loadMessages(data.messages,(error,messages) => setMessages(messages));

                    // }

                })
                .catch((error) => {
                    setLoading(false);
                });


            HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id + "/questions/" + question_id
            })
                .then(response => {
                        setLoading(false);
                        //  const new_q = response.data;
                        // if (JSON.stringify(new_q) !== JSON.stringify(question)) {
                        // really lazy way to compare questions
                        setQuestion(response.data);
                        // }
                    }
                )
                .catch((error) => {
                    setLoading(false);
                });


        }

        const loadMe = () => {
            HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id + "/me"
            })
                .then(response => {
                        setRepresentative(response.data);
                    }
                )
                .catch((error) => {

                });
        }

        loadMe();

        loadData();

        const intervalId = setInterval(loadData, 10000);
        return (() => {
            clearInterval(intervalId);
        });


    }, [meeting_id, question_id]);

    return (
        <Fragment>
            {loading ? (
                <Loading/>
            ) : ((meeting && question && representative) ? (
                <Fragment>
                    <Header messages={messages} user={representative} logo={meeting.logo} meeting={meeting}/>
                    <hr/>

                    <MeetingTitle meeting={meeting}/>

                    <BackButton meeting={meeting} messages={messages} href={"/meeting/question/" + question_id}/>

                    <Box mb={2}>

                        <Typography variant={"h6"}>
                            {question.name}
                        </Typography>
                    </Box>

                    {(typeof question.acclamation !== 'undefined') ? (
                        <Container>
                            {question.acclamation ? (
                                <Typography variant={"h5"}>
                                    {getMessage(props.meeting.meeting_type,'approved_by_acclamation',props.messages)}
                                </Typography>
                            ) : (
                                <Typography variant={"h5"}>
                                    {getMessage(props.meeting.meeting_type,'refuse_by_acclamation',props.messages)}
                                </Typography>
                            )}


                        </Container>

                    ) : (
                        <SearchAnwers meeting={meeting} question={question}/>

                    )}

                </Fragment>
            ) : (
                <Typography>
                    {getMessage('default', 'meeting_not_found', null)}
                </Typography>
            ))}
        </Fragment>

    )
}

export default QuestionAnswers;